export enum TissueImageTypes {
    Specular = "Specular",
    EyeDiagram = "Eye Diagram",
    SlitLamp = "Slit Lamp",
    OCT = "OCT",
    Other = "Other",
}
